module.exports = __webpack_public_path__ + "static/img/2备份 5 2.2beeeba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/milan/2备份 5 2.png
// module id = dgty
// module chunks = 1